<template>
  <div :class="['delivery-form', { 'with-error': approvalByPkwError }]">
    <h2 class="title">Zulassung des Fahrzeugs</h2>

    <div class="hint">
      <p v-if="order.payment_method === 'self_pay'">
       <strong>Hinweis:</strong> Das Fahrzeug muss
        vor Lieferung durch Sie oder uns zugelassen werden.
      </p>
      <p v-if="order.payment_method === 'financing'">
       <strong>Hinweis:</strong> Das Fahrzeug muss
        vor Lieferung zugelassen werden. Im Falle der gewählten Zahlart
        „Online-Finanzierung“ verbleiben die Fahrzeugpapiere so lange im Besitz
        der Bank, bis die letzte Rate überwiesen wurde. Die Zulassung Ihres
        Fahrzeugs muss daher, anders als im Barkauf, zwangsläufig durch PKW.de
        und deren Partner erfolgen.
      </p>
    </div>

    <form>
      <div
        :class="['radio-form-item', { active: registrationType === STANDARD }]"
        @click="() => handleSelectRegistrationType(STANDARD)"
      >
        <input :checked="registrationType === STANDARD" type="radio" />
        <RegistrationByPkw :order="order" />
      </div>
      <div
        :class="['radio-form-item', { active: registrationType === WITH_PLATES }]"
        @click="() => handleSelectRegistrationType(WITH_PLATES)"
      >
        <input :checked="registrationType === WITH_PLATES" type="radio" />
        <RegistrationByPkwWithPlates :order="order" />
      </div>
      <div
        v-if="order.payment_method === 'self_pay'"
        :class="['radio-form-item', { active: registrationType === SELF }]"
        @click="() => handleSelectRegistrationType(SELF)"
      >
        <input :checked="registrationType === SELF" type="radio" />
        <NotApprovedContent :order="order" />
      </div>
      <p v-if="approvalByPkwError" class="error">Bitte Option wählen.</p>
      <div class="btns">
        <button class="btn btn-red" type="button" @click="openModal">
          Fragen zur Zulassung?
        </button>
        <button class="btn" @click="updateOrderData">{{ editMode ? 'Änderungen übernehmen' : 'Nächster Schritt'}}</button>
      </div>
    </form>
    <ServiceInfoModal :is-open="showModal" @close="closeModal" :order="order" />
  </div>
</template>

<script>
import ApprovedContent from "@/components/ApprovedContent";
import RegistrationByPkw from "@/components/RegistrationByPkw";
import RegistrationByPkwWithPlates from "@/components/RegistrationByPkwWithPlates";
import ServiceInfoModal from "@/components/modals/ServiceInfoModal";
import NotApprovedContent from "@/components/NotApprovedContent";

export const STANDARD = 'standard';
export const WITH_PLATES = 'standard_with_license_plate';
export const SELF = 'self';

export default {
  components: {
    ApprovedContent,
    ServiceInfoModal,
    NotApprovedContent,
    RegistrationByPkw,
    RegistrationByPkwWithPlates
},
  props: ["order", 'editMode'],
  data() {
    return {
      registrationType: this.order.registration_service || undefined ,
      approvalByPkwError: false,
      showModal: false,
      STANDARD,
      WITH_PLATES,
      SELF,
    };
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 990;
    },
  },
  watch: {
    registrationType(val) {
      if (val && this.approvalByPkwError) {
        this.approvalByPkwError = false;
      }
    },
  },
  methods: {
    updateOrderData(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        const params = {
          registration_service: this.registrationType,
        };
        this.$emit("updateOrderStep", this.order.token, params);
      }
    },
    validateForm() {
      let noError = true;
      if (this.registrationType === undefined) {
        this.approvalByPkwError = true;
        noError = false;
      } else {
        this.approvalByPkwError = false;
      }
      if (noError) {
        this.approvalByPkwError = false;
      }
      return noError;
    },
    handleSelectRegistrationType(value) {
      this.registrationType = value;
    },
    editData() {
      this.$emit("editData");
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.hint {
  margin-bottom: 20px;
  font-size: 14px;
  color:$blue;

  a {
    color: $blue;
    text-decoration: underline;
  }
}

.delivery-form {
  padding: 30px 0.625rem;

  @include breakpoint(desktop) {
    padding: 30px 0;
  }

  .radio-form-item {
    margin-bottom: 10px;
  }
  .check-list {
    margin-top: 20px;
  }
  .btn {
    margin-top: 10px;
  }
  &.with-error {
    .radio-form-item {
      border-color: $red;
    }
    .title {
      color: $red;
    }
    .error {
      font-size: 12px;
      line-height: 24px;
      color: $red;
    }
  }
  @include breakpoint(desktop) {
  }
}
</style>
